import { api } from '@/api'
import type { AuthResponse } from '@/api/auth/models'
import router from '@/router'
import { accessToken, refreshToken, deviceId as deviceIdStorage } from '@/storages'
import { v4 as uuidv4 } from 'uuid'

class AuthService {
  private refreshingPromise: null | Promise<AuthResponse> = null

  get deviceId() {
    const deviceId = deviceIdStorage.get()
    if (deviceId) {
      return deviceId
    }

    const newId = uuidv4()
    deviceIdStorage.set(newId)
    return newId
  }

  dropTokens() {
    accessToken.remove()
    refreshToken.remove()
  }

  get isAuthorized(): boolean {
    return refreshToken.exist
  }

  async login(initData: string) {
    const { access_token, refresh_token, success } = await api.auth.login({
      payload: { initData, deviceId: this.deviceId }
    })

    if (!success) {
      return false
    }

    accessToken.set(access_token)
    refreshToken.set(refresh_token)
    return true
  }

  async refresh() {
    if (!this.isAuthorized) {
      router.push('/auth')
      return
    }
    if (this.refreshingPromise) {
      return await this.refreshingPromise
    }
    this.refreshingPromise = api.auth.refresh({
      payload: { refreshToken: refreshToken.get()!, deviceId: this.deviceId }
    })
    const { access_token } = await this.refreshingPromise
    this.refreshingPromise = null
    if (access_token) {
      accessToken.set(access_token)
    } else {
      this.dropTokens()
      router.push('/auth')
    }
  }
}

export const authService = new AuthService()
